"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesEnum = exports.InternalRolesEnum = void 0;
// Internal roles are roles that can be assigned from the management user page UI
var InternalRolesEnum;
(function (InternalRolesEnum) {
    InternalRolesEnum["ManagementAccess"] = "management-access";
    InternalRolesEnum["CustomerSupport"] = "customer-support";
    InternalRolesEnum["DriverSupport"] = "driver-support";
    InternalRolesEnum["ContentManager"] = "content-manager";
    InternalRolesEnum["CampaignsManager"] = "campaigns-manager";
    InternalRolesEnum["BizDev"] = "bizdev";
    InternalRolesEnum["RegionalManager"] = "regional-manager";
    InternalRolesEnum["SeniorRegionalManager"] = "senior-regional-manager";
    InternalRolesEnum["SupportMaster"] = "support-master";
    InternalRolesEnum["ClaimingToolSubscriptionMaster"] = "claiming-tool-subscription-master";
    InternalRolesEnum["RefundMaster"] = "refund-master";
    InternalRolesEnum["PayoutMaster"] = "payout-master";
    InternalRolesEnum["CAMaster"] = "ca-master";
    InternalRolesEnum["Finance"] = "finance";
    InternalRolesEnum["FinanceMaster"] = "finance-master";
    InternalRolesEnum["Product"] = "product";
    InternalRolesEnum["Admin"] = "admin";
    InternalRolesEnum["UserRoleManager"] = "user-role-manager";
})(InternalRolesEnum || (exports.InternalRolesEnum = InternalRolesEnum = {}));
var RolesEnum;
(function (RolesEnum) {
    // -- Internal roles. Assignable from users page and stored in DB. --
    // TODO(mg): dissolve this role by assigning its permissions to all roles having it assigned.
    // Plus adjust the logic allowing logging in to management based on this role presence
    RolesEnum["ManagementAccess"] = "management-access";
    RolesEnum["CustomerSupport"] = "customer-support";
    RolesEnum["DriverSupport"] = "driver-support";
    RolesEnum["ContentManager"] = "content-manager";
    RolesEnum["CampaignsManager"] = "campaigns-manager";
    RolesEnum["BizDev"] = "bizdev";
    RolesEnum["RegionalManager"] = "regional-manager";
    RolesEnum["SeniorRegionalManager"] = "senior-regional-manager";
    RolesEnum["SupportMaster"] = "support-master";
    RolesEnum["ClaimingToolSubscriptionMaster"] = "claiming-tool-subscription-master";
    RolesEnum["RefundMaster"] = "refund-master";
    RolesEnum["PayoutMaster"] = "payout-master";
    RolesEnum["CAMaster"] = "ca-master";
    RolesEnum["Finance"] = "finance";
    RolesEnum["FinanceMaster"] = "finance-master";
    RolesEnum["Product"] = "product";
    RolesEnum["Admin"] = "admin";
    RolesEnum["UserRoleManager"] = "user-role-manager";
    // -- Roles not assignable from users page. Assigned from code and stored in DB --
    RolesEnum["Driver"] = "driver";
    RolesEnum["DriversCompany"] = "drivers-company";
    RolesEnum["DriversCompanyDriver"] = "drivers-company-driver";
    RolesEnum["CanClaimTrips"] = "can-claim-trips";
    // -- Customer and TravelAgent related roles. Never stored in DB but assigned on login time --
    RolesEnum["SiteCustomer"] = "site-customer";
    RolesEnum["CustomerInterface"] = "site-customer-customer-interface";
    RolesEnum["SiteCustomerBookingProcess"] = "site-customer-booking-process";
    RolesEnum["SiteCustomerTripTracking"] = "site-customer-trip-tracking";
    RolesEnum["TravelAgent"] = "travel-agent";
    // -- Integration roles assigned in DB only
    RolesEnum["BlacklistedDatesApiIntegration"] = "blacklisted-dates-api-integration";
    RolesEnum["Developer"] = "developer";
})(RolesEnum || (exports.RolesEnum = RolesEnum = {}));
//# sourceMappingURL=AllRoles.js.map